export default __webpack_public_path__ + "static/media/customer.5ed6990a.svg";